import React from 'react';
import { Twitter, Instagram, Linkedin, Github } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy text-white py-8 px-6 md:px-12 border-t border-white/10" data-id="element-126">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-127">
        <div className="flex items-center gap-2" data-id="element-128">
          <div className="w-4 h-4 bg-coral rotate-45" data-id="element-129" />
          <span className="font-mono text-sm tracking-widest" data-id="element-130">
            © 2026 COFFRETRESOR
          </span>
        </div>

        <div className="flex gap-6" data-id="element-131">
          {[Twitter, Instagram, Linkedin, Github].map((Icon, i) => <a key={i} href="#" className="hover:text-coral transition-colors" data-id="element-132">
              <Icon className="w-5 h-5" data-id="element-133" />
            </a>)}
        </div>
      </div>
    </footer>;
}